import type { InventoryFilterState } from "../lib/url-state";

export const stockKeys = {
  all: ["stock"] as const,
  lists: ["stock", "list"] as const,
  list: (filter: InventoryFilterState) => ["stock", "list", filter] as const,
  search: (term: string) => ["stock", "search", term] as const,
  detail: (sku: string, mkp: string) => ["stock", "detail", sku, mkp] as const,
  audit: (sku: string, mkp: string) => ["stock", "audit", sku, mkp] as const,
  sellerRef: (sku: string, mkp: string) => ["stock", "seller-ref", sku, mkp] as const,
};

export const ratioKeys = {
  all: ["ratio"] as const,
  lists: ["ratio", "list"] as const,
  list: (offset: number, limit: number) => ["ratio", "list", { offset, limit }] as const,
  detail: (sku: string) => ["ratio", "detail", sku] as const,
};

export const skuBrandKeys = {
  all: ["sku-brands"] as const,
  apNames: ["sku-brands", "ap-names"] as const,
  unmapped: (f: { search: string; offset: number; limit: number }) =>
    ["sku-brands", "unmapped", f] as const,
  lastImport: ["sku-brands", "last-import"] as const,
};
